import * as actionType from './type';

export const requestShowLoader = () => (dispatch) => {
    dispatch({
        type: actionType.REQUEST_SHOW_LOADER
    })
}

export const requestHideLoader = () => (dispatch) => {
    dispatch({
        type: actionType.REQUEST_HIDE_LOADER
    })
}

export const handlegetallnotification = () => (dispatch) => {

    try {

    } catch (error) {

    }
}

export const handlemarkAsSeenAllNotification = () => (dispatch) => {

    try {



    } catch(error) {



    }
}

export const handleCreateEditConfiguration = (action) => (dispatch) => {
    
    try {

        dispatch({
            type: actionType?.CREATE_EDIT_CONFIGURATION,
            payload: action
        });

    } catch(error) {



    }
}
